import { createFileRoute } from '@tanstack/react-router'
import { SignalHirePlayground } from '@/features/admin/signalhire-playground'

export const Route = createFileRoute('/_authenticated/admin/signalhire-playground')({
  component: SignalHirePlayground,
})
